<template>
    <activation-preview-provider
        v-slot="{
            brief,
            step,
        }"
        :module-name="moduleName"
    >
        <activation-brief-tasks-view
            v-if="brief"
            :brief="brief"
            :step="step"
            :is-preview="true"
        />
        <g-loader v-else type="fixed" />
    </activation-preview-provider>
</template>

<script>
    import ActivationPreviewProvider from '../../providers/preview-providers/ActivationPreviewProvider';
    import ActivationBriefTasksView from '../../data-views/activation-briefs/ActivationBriefTasksView';
    import PageMask from '../../library/PageMask';
    import {NAME_TASKS} from '../../../constants/activation-brief-steps';

    export default {
        name:       'ActivationTasksPreviewRouterView',
        components: {
            ActivationBriefTasksView,
            ActivationPreviewProvider,
            PageMask,
        },
        data() {
            return {
                moduleName: NAME_TASKS,
            };
        },
    };
</script>
